<div class="flex-row center-end">
  <img src="assets/ui/credit-card-flags/visa.png" alt="" srcset="" />
  <img src="assets/ui/credit-card-flags/master.png" alt="" srcset="" />
  <img src="assets/ui/credit-card-flags/hipercard.png" alt="" srcset="" />
  <img src="assets/ui/credit-card-flags/amex.png" alt="" srcset="" />
  <img src="assets/ui/credit-card-flags/dinners.png" alt="" srcset="" />
  <img src="assets/ui/credit-card-flags/elo.png" alt="" srcset="" />
</div>
